import React, {useEffect, useState} from 'react';
// mocks
import {machineListData} from '../../../mocks/machineList';

import RiskAccessCard from '../../../components/risk-assess-card/risk-access.card';
import MachineCard from './components/machine-card/machineCard';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {crumbHref, crumbLabel, currentPath} from './utils/breadcrumb';
import Loader from '../../../components/loader/loader';
import {useDispatch, useSelector} from 'react-redux';
import {
  getBreadcrumbSelector,
  getRiskAssessmentLoadingState,
} from '../../../redux/selectors/riskAssessment';
import {assets} from '../../../utils/assetsSrc';
import './assessment.scss';
import {
  clearProductModelsData,
  createBreadcrumbs,
} from '../../../redux/risk-assessment/riskAssessmentSlice';
import {getItemFromSession, sessionAttributes} from './utils/sessionStorage';
import { Tooltip } from '@mui/material';

const breadcrumbSequence = [
  'product-line',
  'product-models',
  'risk-assessments',
  'risk-assessment',
  'device-detail',
  'task-detail',
  'event-detail',
];

export default function Assessment() {
  const location = useLocation();
  const nav = useNavigate();
  const isLoading = useSelector(getRiskAssessmentLoadingState());
  const dynamicCrumbs = [
    'product-models',
    'risk-assessments',
    'risk-assessment',
    'device-detail',
    'task-detail',
    'event-detail',
  ];
  // const breadcrumbs = useSelector(getBreadcrumbSelector());
  // const [navList, setNavList] = useState(breadcrumbs ?? []);
  const [navList, setNavList] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    const pathName = location.pathname;
    const paths = pathName
      .split('/')
      .filter(path => path !== '')
      .slice(2);
    if (paths[0] === 'product-line') {
      setNavList([]);
      // dispatch(createBreadcrumbs([]));

      return;
    }

    const currentPath = paths[0] ?? 'product-line';

    const currentElement = navList.findIndex(
      item => item?.name === currentPath,
    );

    if (currentElement === -1) {
      // Show the device crumb only on the device page itself. Tasks are never opened from a device,
      // and the last opened device stays in the navigation state, so it can't be used to decide this.
      const requiredPaths = breadcrumbSequence
        .slice(0, breadcrumbSequence.indexOf(currentPath) + 1)
        .filter(path => path !== 'device-detail' || currentPath === 'device-detail');

      const list = createBreadCrumbNav(requiredPaths, []);

      setNavList(list);
    } else {
      const list = createBreadCrumbNav(paths, navList);

      setNavList(list);
    }
    // createBreadCrumbNav(paths);
  }, [location]);

  const manageDynamicCrumbData = path => {
    if (!location.state) {
      nav(crumbHref['product-line']);
      return;
    }

    let element;
    switch (path) {
      case 'product-models':
        element = {
          name: 'product-models',

          // label: location.state.selectedRiskAssessment === 'all' ? `Assessments(${location.state.raCount??'all'})` : location.state.selectedRiskAssessment,
          label: location.state?.selectedProductLine?.name || '--',
          onClick: (val = true) => {
            if (val) {
              const index = navList.findIndex(el => el.name === path);

              const newNavList = navList.slice(index + 1);

              // dispatch(createBreadcrumbs(newNavList));

              nav(crumbHref[path], {state: {...location.state}});
            }
          },
        };
        return element;
      case 'risk-assessments':
        element = {
          name: 'risk-assessments',

          // label: location.state.selectedRiskAssessment === 'all' ? `Assessments(${location.state.raCount??'all'})` : location.state.selectedRiskAssessment,
          label: location.state?.selectedModel?.name || '--',
          onClick: (val = true) => {
            if (val) {
              const index = navList.findIndex(el => el.name === path);

              const newNavList = navList.slice(index + 1);

              // dispatch(createBreadcrumbs(newNavList));

              nav(crumbHref[path], {state: {...location.state}});
            }
          },
        };
        return element;
      case 'risk-assessment':
        element = {
          name: 'risk-assessment',
          label: location.state.selectedRiskAssessment?.name || '--',
          onClick: (val = true) => {
            if (val) {
              const index = navList.findIndex(el => el.name === path);
              const newNavList = navList.slice(index + 1);

              setNavList(newNavList);
              // dispatch(createBreadcrumbs(newNavList));

              nav(crumbHref[path], {state: {...location.state}});
            }
          },
        };
        return element;
      case 'task-detail':
        element = {
          name: 'task-detail',
          label: location.state.selectedTask?.name || '--',
          onClick: (val = true) => {
            if (val) {
              const index = navList.findIndex(el => el.name === path);

              const newNavList = navList.slice(index + 1);

              setNavList(newNavList);
              // dispatch(createBreadcrumbs(newNavList));
              nav(crumbHref[path], {state: {...location.state}});
            }
          },
        };
        return element;
      case 'device-detail':
        element = {
          name: 'device-detail',
          label: location.state.selectedDevice?.name || '--',
          onClick: (val = false) => {},
        };

        return element;
      case 'event-detail':
        element = {
          name: 'event-detail',
          label: location.state.selectedEventName || '--',
          onClick: (val = false) => {},
        };

        return element;
      default:
        return {};
    }

    return element;
  };

  const createBreadCrumbNav = (paths, navListItems) => {
    let newNavList = [...navListItems];

    paths.forEach(path => {
      if (!!newNavList.find(el => el?.name === path)?.name) {
        const indexOf = newNavList.findIndex(el => el.name === path);
        newNavList = newNavList.slice(0, indexOf + 1);
        // Update the breadcrumb data with the latest information
        if (dynamicCrumbs.includes(path)) {
          const newCrumbData = manageDynamicCrumbData(path);
          newNavList[indexOf] = newCrumbData;
        }
      } else if (dynamicCrumbs.includes(path)) {
        const element = manageDynamicCrumbData(path);
        newNavList.push(element);
      } else {
        let el = {
          name: path,
          label: crumbLabel[path],
          // href:crumbHref[path]
          onClick: (val = true) => {
            if (val) {
              const index = newNavList.findIndex(el => el.name === path);
              setNavList(newNavList.slice(index + 1));
              nav(crumbHref[path], {state: {...location.state}});
            }
          },
        };
        newNavList.push(el);
      }
    });

    // setNavList(newNavList);
    // dispatch(createBreadcrumbs(newNavList));

    return newNavList;
  };

  return (
    <div className="main-section-wrapper">
      <Breadcrumbs
        separator={<img src={assets.chevronRight} />}
        aria-label="breadcrumb">
        {navList?.length &&
          navList.map((listItem, index) => (
            <Tooltip
            key={listItem?.label}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)', // black with opacity
                    color: 'white',
                    fontSize: '13px',
                    maxWidth: '300px',
                    backdropFilter: 'blur(4px)', // optional blur for a soft effect
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)', // adds depth
                    borderRadius: '8px',
                    padding: '10px',
                  },
                },
              }}
              title={listItem?.label}>
              <Link
                
                className={
                  index === navList.length - 1 ? 'disable-click-current' : ''
                }
                underline="hover"
                color="inherit"
                onClick={() => {
                  if (index !== navList.length - 1) {
                    const index = navList.findIndex(
                      el => el.name === listItem?.name,
                    );

                    const newNavList = navList.slice(0, index + 1);
                    setNavList(newNavList);

                    nav(crumbHref[listItem?.name], {
                      state: {...location.state},
                    });
                  }

                  // index === navList.length - 1
                  //   ? listItem.onClick(false)
                  //   : listItem.onClick();
                }}>
                {index === 0 && <img src={assets.backArrow} />}
                {listItem?.label}
              </Link>
            </Tooltip>
          ))}
      </Breadcrumbs>
      <Outlet></Outlet>
      {isLoading && <Loader />}
    </div>
  );
}
